module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACGSURBVFiF7dfBCYAwEETRSbSaWIS2YxXGKoLdaBN2o2sHDisEc5h33g0fAoEEfJCK5RCxvM3YjfWcQ/aeHb8E1aQgRkGMghgFMQpimgsKqVh2L3UYYZjeh7DbhcN99rCZeZdqau7KFMQoiFEQ09uN1btU9WH0LgD6Bv1LQYyCGAUxCmIUxDzpYx/HPPuZWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_add.png
// module id = 3zgV
// module chunks = 1